import React from 'react'

export default function Hero() {
  return (
    <>
      <h1>Hero</h1>
      <p><span className='tag-grey bold'>.hero</span> class creates a large hero element that takes the full width of the container </p>
      <p>use the class <span className='tag-grey bold'>.full-hero</span> to make the hero's height take the height of the screen</p>
    
      <h2>Code:</h2>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;div class="hero"&gt; <br/>
            &lt;p class="hero-header"&gt;hero text&lt;/p&gt; <br/>
            &lt;p class="hero-text"&gt;hero text&lt;/p&gt; <br/>
            &lt;p class="hero-subtext"&gt;hero sub text&lt;/p&gt; <br/>
            &lt;/div&gt;  
          </p>
      </div>

      <h2>Result:</h2>
      <div className='border-grey border-curve'>
      <div className="hero">
            <p className="hero-header">hero text</p>
            <p className="hero-text">hero text</p>
            <p className="hero-subtext">hero sub text</p>
        </div>  
      </div>
    </>
  )
}
